var f = Object.defineProperty, i = Object.defineProperties;
var p = Object.getOwnPropertyDescriptors;
var t = Object.getOwnPropertySymbols;
var s = Object.prototype.hasOwnProperty, g = Object.prototype.propertyIsEnumerable;
var a = (e, o, r) => o in e ? f(e, o, { enumerable: !0, configurable: !0, writable: !0, value: r }) : e[o] = r, m = (e, o) => {
  for (var r in o || (o = {}))
    s.call(o, r) && a(e, r, o[r]);
  if (t)
    for (var r of t(o))
      g.call(o, r) && a(e, r, o[r]);
  return e;
}, c = (e, o) => i(e, p(o));
import n, { forwardRef as b } from "react";
import d from "../lib/IconBase.mjs";
import k from "../defs/FacebookLogo.mjs";
const l = b((e, o) => /* @__PURE__ */ n.createElement(d, c(m({ ref: o }, e), { weights: k })));
l.displayName = "FacebookLogo";
export {
  l as FacebookLogo
};
